import { render, staticRenderFns } from "./FormatEdit.vue?vue&type=template&id=549178c5&scoped=true&"
import script from "./FormatEdit.vue?vue&type=script&lang=js&"
export * from "./FormatEdit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/formats.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./FormatEdit.vue?vue&type=style&index=1&id=549178c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549178c5",
  null
  
)

export default component.exports